module.exports = __webpack_public_path__ + "img/dump-combo-body.5738c1bb.png";